import React from "react"
import PropTypes from "prop-types"
import { Table } from "antd"

import { IndexBatchFilesOutputShape } from "@api/services/backstage"
import { IndexTransactionsOutputShape } from "@api/services/transactions"

import useColumns from "./helpers/useColumns"
import useDataSource from "./helpers/useDataSource"
import useAttachmentsCount from "./helpers/useAttachmentsCount"
import { InvestmentShape } from "../shapes"
import InvestmentAttachmentsTable from "./InvestmentAttachmentsTable"


const InvestmentsTransferTable = ({
  table,
  sourceProjectId = undefined,
  sourceFiles,
  sourceInvestments,
  sourceTransactions,
  getSourceBatchName,
  targetProjectId = undefined,
  targetInvestments,
  customAmounts,
  customTargets,
  setCustomTargets,
}) => {
  const getInvestmentAttachmentsCount = useAttachmentsCount({
    sourceFiles,
    sourceTransactions
  })

  const columns = useColumns({
    targetProjectId,
    sourceProjectId,
    sourceInvestments,
    targetInvestments,
    getInvestmentAttachmentsCount,
    customAmounts,
    customTargets,
    setCustomTargets,
  })

  const dataSource = useDataSource({
    customTargets,
    sourceInvestments,
    targetInvestments,
  })

  table.current.getDataSource = () => dataSource

  const expandedRowRender = (investment) => {
    const { id, isIncluded, sourceInvestmentId } = investment

    let files = []
    let transactions = []
    let investmentId = id
    let getBatchName = getSourceBatchName

    if (isIncluded) {
      files = sourceFiles
      transactions = sourceTransactions
      investmentId = sourceInvestmentId || id
      getBatchName = getSourceBatchName
    }

    return (
      <InvestmentAttachmentsTable
        files={files}
        transactions={transactions}
        investmentId={investmentId}
        getBatchName={getBatchName}
      />
    )
  }

  const tableProps = {
    size: "middle",
    rowKey: "id",
    bordered: true,
    pagination: false,
    expandable: {
      rowExpandable: investment => !!getInvestmentAttachmentsCount(investment),
      expandedRowRender
    },
    columns,
    dataSource
  }

  return (
    <Table {...tableProps} />
  )
}

InvestmentsTransferTable.propTypes = {
  table: PropTypes.shape().isRequired,
  targetProjectId: PropTypes.string,
  sourceProjectId: PropTypes.string,
  getSourceBatchName: PropTypes.func.isRequired,
  sourceFiles: PropTypes.arrayOf(IndexBatchFilesOutputShape).isRequired,
  sourceInvestments: PropTypes.arrayOf(InvestmentShape).isRequired,
  sourceTransactions: PropTypes.arrayOf(IndexTransactionsOutputShape).isRequired,
  targetInvestments: PropTypes.arrayOf(InvestmentShape).isRequired,
  customAmounts: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  customTargets: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  setCustomTargets: PropTypes.func.isRequired,
}

export default InvestmentsTransferTable
